var ClickableOption = /*@__PURE__*/ (function () {
    function ClickableOption(value, label, callback, unit) {
        if (unit === void 0) {
            unit = null;
        }
        this.label = label;
        this.value = value;
        this.element = document.createElement("div");
        this.onClickFn = callback;
        this.unit = unit;
    }
    ClickableOption.prototype.render = function () {
        return this.element;
    };
    ClickableOption.prototype.setUp = function () {
        var _this = this;
        this.element.innerHTML = this.template;
        this.element = this.element.childNodes[0];
        this.element.addEventListener("click", function () {
            if (!_this.disabled) {
                _this.onClickFn(_this);
            }
        });
    };
    ClickableOption.prototype.getLabel = function () {
        return this.label;
    };
    ClickableOption.prototype.getValue = function () {
        return this.value;
    };
    ClickableOption.prototype.getUnit = function () {
        return this.unit;
    };
    ClickableOption.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        if (disabled) {
            this.element.classList.add(this.disabledStyleClass);
        }
        else {
            this.element.classList.remove(this.disabledStyleClass);
        }
    };
    ClickableOption.prototype.setSelected = function (selected) {
        if (selected) {
            this.element.classList.add(this.activeStyleClass);
        }
        else {
            this.element.classList.remove(this.activeStyleClass);
        }
    };
    return ClickableOption;
}());
export { ClickableOption };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/shared/ClickableOption.ts
// module id = null
// module chunks = 